import { IUser } from '../../models/index';

export interface AuthState {
  initializing: boolean;
  isAuthenticated: boolean;
  user: IUser | null;
  token: string | null;
  error: string | null; // Para mensajes de error del login
  loading: boolean; // Para indicar si una operación de autenticación está en curso
}

export const initialAuthState: AuthState = {
  initializing: true,
  isAuthenticated: false,
  user: null,
  token: null,
  error: null,
  loading: false,
};
